<template>
<b-card class="rounded-lg">
  <template #header>
    <div class="d-flex justify-content-between align-items-center w-100 pb-1" style="border-bottom: 2px solid rgb(238, 238, 238);">
      <h4 class="text-dark m-0">
        Vitals
      </h4>
    </div>
  </template>
  
  <div class="card-body">
    <div class="d-flex align-items-center justify-content-between">
      <div class="w-50 d-flex align-items-center flex-column pr-1">
        <b-img src="@/assets/images/health/hearth.png" style="width: 60px;"></b-img>
        <h5 class="lead text-muted text-center mt-2">Blood Pressure</h5>
        <h1 class="text-dark text-center">
          <strong>
          {{ getValueFromSource(consultationData, 'vitals.blood_pressure.systolic', 0) }} / {{ getValueFromSource(consultationData, 'vitals.blood_pressure.diastolic', 0) }} 
          </strong>
        </h1>
      </div>

      <div class="w-50 d-flex align-items-center flex-column pl-1" style="border-left: 2px dotted rgb(238, 238, 238);">
        <b-img src="@/assets/images/health/pulse.png" style="width: 60px;"></b-img>
        <h5 class="lead text-muted text-center mt-2">Pulse</h5>
        <h1 class="text-dark text-center">
          <strong>
            {{ getValueFromSource(consultationData, 'vitals.heart_rate', 0) }} BPM
          </strong>
        </h1>
      </div>
    </div>
  </div>
</b-card>
</template>

<script>
import {
  BRow,
  BCol,
  BImg,
  BCard,
  BBadge,
  BAlert,
  BButton,
  BAvatar,
  BDropdown,
  BDropdownItem,
  BDropdownGroup
} from 'bootstrap-vue'

import UserViewActionCard from "./UserViewActionCard.vue";

export default {
  components: {
    BRow,
    BCol,
    BImg,
    BCard,
    BBadge,
    BAlert,
    BAvatar,
    BButton,
    BDropdown,
    BDropdownItem,
    BDropdownGroup,

    UserViewActionCard,
  },
  props: {
    patientData: {
      type: Object,
      required: true,
    },
    consultationData: {
      type: Object,
      default: null,
      required: false,
    },
  },
  setup() {},
}
</script>

<style scoped>
.profile-highlight {
  font-size: 18px !important;
}
.profile-highlight-title {
  font-size: 16px !important;
  color: lightgray;
  font-weight: normal;
}

.patient-name {
  font-size: 25px;
}
</style>
